import {
  Home as HomeIcon,
  Dashboard as DashboardIcon,
  Psychology as PsychologyIcon,
  Storage as StorageIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  ModelTraining as ModelTrainingIcon,
  Storefront as StorefrontIcon,
  Help as HelpIcon,
  AutoFixHigh as AutoFixHighIcon,
  Terminal as TerminalIcon,
  Science as ScienceIcon,
  Rocket as RocketIcon,
  Chat as ChatIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';

export const menuItems = [
  { label: 'Home', icon: HomeIcon, path: '/home' },
  { label: 'Dashboard', icon: DashboardIcon, path: '/dashboard', comingSoon: false },
  { label: 'Agent Studio', icon: RocketIcon, path: '/agent-studio' },
  { label: 'Cloud Management', icon: StorageIcon, path: '/cloud-management', comingSoon: false },
  { label: 'Apphub', icon: StorefrontIcon, path: '/apphub', comingSoon: false, preview: true },
];

export const appHighlightItems = [];

export const bottomMenuItems = [
  { label: 'Admin', icon: AdminIcon, path: '/admin' },
  { label: 'Settings', icon: SettingsIcon, path: '/settings' },
  { 
    label: 'Logout', 
    icon: LogoutIcon, 
    action: 'logout'
  },
];
